/**
 * Run `task` for each item, at most `limit` at a time, in order. A failed
 * task is logged and the rest carry on. `shouldStop` is checked before each
 * new task starts, so a Stop button can end a long run early.
 */
export async function runWithConcurrency<T>(
  items: readonly T[],
  limit: number,
  task: (item: T) => Promise<void>,
  shouldStop: () => boolean = () => false,
): Promise<void> {
  let next = 0;
  const worker = async () => {
    while (next < items.length && !shouldStop()) {
      const item = items[next++];
      try {
        await task(item);
      } catch (err) {
        console.error('[runWithConcurrency] Task failed', { item, err });
      }
    }
  };
  await Promise.all(Array.from({ length: Math.max(1, Math.min(limit, items.length)) }, worker));
}
